export default {
    methods: {
        isEmpty(value) {
            if (value === '') {
                return false
            } else {
                return true
            }
        },
        isEmptyObject(value) {
            if (Object.keys(value).length === 0) {
                return false 
            } else {
                return true
            }
        },
        isEmptyArray(value) {
            if (!value.length) {
                return false
            } else {
                return true
            }
        }
    }
}